<template>
  <div>
    <h1>{{ api_version }}</h1>
  </div>
</template>
<script>
import apiVersionService from "../../services/api-version.service";

export default {
  data() {
    return {
      api_version: null,
    };
  },
  methods: {
    async getApiVersion() {
      const { data } = await apiVersionService.getApiVibe();
      console.log(data);
      this.api_version = data;
    },
  },
  mounted() {
    this.getApiVersion();
  },
};
</script>
